import React from 'react';
import contactDataJson from './contactData.json';
import instagramIcon from '../../assets/images/contact-letter/instagram_icon.png';
import logo from '../../assets/images/contact-letter/logo.png';
import emailIcon from '../../assets/images/contact-letter/mail_icon.png';
import phoneIcon from '../../assets/images/contact-letter/phone_icon.png';
import rectorSign from '../../assets/images/contact-letter/rector_sign.png';
import rectorStamp from '../../assets/images/contact-letter/rector_stamp.png';
import telegramIcon from '../../assets/images/contact-letter/telegram_icon.png';
import websiteIcon from '../../assets/images/contact-letter/web_icon.png';
import { dateFormatter } from '../../helpers/date-formatter';
import boldFont from '../../assets/fonts/Roboto-Bold.ttf';
import regularFont from '../../assets/fonts/Roboto-Regular.ttf';

import {
  PDFViewer,
  Document,
  Font,
  Image,
  Link,
  Page,
  StyleSheet,
  Text,
  View,
} from '@react-pdf/renderer';

Font.register({
  family: 'Roboto',
  src: regularFont,
  fontWeight: 'normal',
  fonts: [
    { src: regularFont },
    {
      src: boldFont,
      fontWeight: 'bold',
    },
  ],
});


const styles = StyleSheet.create({
  pdf: {
    fontFamily: 'Roboto',
    padding: 30,
    fontSize: 12,
    textAlign: 'justify',
  },
  flex: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  flex_around: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  flex_end: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  dFlex: {
    display: 'flex',
    flexDirection: 'row',
  },
  width33: {
    width: '33.33%',
  },
  header: {
    borderBottom: '4px solid #18164B',
    paddingBottom: 10,
  },
  textHeader: {
    textAlign: 'center',
  },
  title_wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  address: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
  },
  address_icon: {
    width: 15,
    height: 15,
  },
  address_media: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 3,
    marginTop: 15,
  },
  body: {},
  bold: {
    fontWeight: 'bold',
  },
  image: {
    width: 60,
    height: 60,
  },
  section: {
    marginTop: 2,
  },
  first_section: {
    marginTop: 10,
  },
  section_title: {
    margin: 'auto',
    fontWeight: 'bold',
  },
  rector: {
    marginTop: 20,
    fontWeight: 'bold',
  },
  logo: {
    width: 90,
    height: 90,
  },
  rector_stamp: {
    width: 110,
    height: 110,
  },
});

Font.registerHyphenationCallback((word) => [word]);

export default function ContactLetterFile({
  contactData,
  data = contactDataJson,
}) {
  return (
    <PDFViewer width={"100%"} height={1200} showToolbar={false}>
      <Document>
        <Page size="A4" style={styles.pdf}>
          <View style={styles.header}>
            <View style={styles.flex}>
              <View style={styles.width33}>
                <Text style={styles.textHeader}>
                  <Link href={'https://edu.uz/ru'}>{data.header.title.russianLink}</Link>
                  {data.header.title.russianText}
                </Text>
              </View>
              <View>
                <Image style={styles.logo} src={logo} />
              </View>
              <View style={styles.width33}>
                <Text style={styles.textHeader}>{data.header.title.englishText}</Text>
              </View>
            </View>
            <View style={{ ...styles.flex, marginTop: 20 }}>
              <Text style={{ fontSize: 10, width: 200 }} wrap>
                {contactData?.branch?.address?.adress_line_2}
              </Text>
              <Text style={{ fontSize: 10, width: 200 }} wrap>
                {contactData?.branch?.address?.adress_line_1}
              </Text>
            </View>
            <View style={styles.flex}>
              <View style={styles.address_media}>
                <Image style={styles.address_icon} src={phoneIcon} />
                <Text>{data.header.address.phone}</Text>
              </View>
              <View style={styles.address_media}>
                <Image style={styles.address_icon} src={websiteIcon} />
                <Text>
                  <Link href={data.header.address.website}>
                    {data.header.address.website}
                  </Link>
                </Text>
              </View>
              <View style={styles.address_media}>
                <Image style={styles.address_icon} src={emailIcon} />
                <Text style={{ color: 'blue' }}>{data.header.address.email}</Text>
              </View>
              <View style={styles.address_media}>
                <Image style={styles.address_icon} src={instagramIcon} />
                <Text>{data.header.address.instagram}</Text>
              </View>
              <View style={styles.address_media}>
                <Image style={styles.address_icon} src={telegramIcon} />
                <Text>
                  <Link href={data.header.address.telegramLink}>
                    {data.header.address.telegram}
                  </Link>
                </Text>
              </View>
            </View>
          </View>
          <View style={{ ...styles.flex_around, marginVertical: 25, fontWeight: 'bold' }}>
            <Text>{dateFormatter(contactData?.contact_date)} г.</Text>
            <Text>№ {contactData?.contract_number}</Text>
            <Text>г.Карши</Text>
          </View>
          <View style={styles.body}>
            <View style={styles.flex_end}>
              <Text style={{ width: '40%', textAlign: 'left', fontWeight: 'bold' }}>
                Ректору {contactData?.studied_university_cyrl}
              </Text>
            </View>
            <View style={{ marginTop: 10 }}>
              <Text style={{ textIndent: 25 }}>
                {data.body.section1.content1} {contactData?.student_full_name_cyrl},{' '}
                {data.body.section1.content2} «{contactData?.study_direction}».
              </Text>
              <Text style={{ textIndent: 25 }}>{data.body.section2.content1}</Text>
              <Text style={{ textIndent: 25 }}>{data.body.section2.content2}</Text>
              <Text style={{ textIndent: 25 }}>{data.body.section2.content3}</Text>
              <Text style={{ textIndent: 25 }}>{data.body.section2.content4}</Text>
              <Text style={{ textIndent: 25 }}>{data.body.section2.content5}</Text>
              <Text style={{ textIndent: 25 }}>{data.body.section2.content6}</Text>
              <Text style={{ textIndent: 25 }}>{data.body.section2.content7}</Text>
              <Text style={{ textIndent: 25 }}>{data.body.section2.content8}</Text>
              <Text style={{ textIndent: 25 }}>С уважением,</Text>
              <View style={styles.flex_around}>
                <Text style={styles.bold}>Ректор</Text>
                <Image style={styles.rector_stamp} src={rectorStamp} />
                <Image style={styles.image} src={rectorSign} />
                <Text style={styles.bold}>О.Н.Бозоров</Text>
              </View>
              <View style={[styles.flex, { marginTop: 20 }]}>
                <Text style={styles.bold}>Тел: +998 78 113 19 19</Text>
                {/* <Image style={{ width: 80, height: 80 }} src={ipuWebsiteLink} /> */}
              </View>
            </View>
          </View>
        </Page>
      </Document>
    </PDFViewer>
  );
};
